import Container from "components/Container";
import PageHeader from "components/Page/PageHeader/index";
import CardDefault from "components/Cards/CardDefault/index";
import { Box, Text, Flex } from "@chakra-ui/react";
import { Row, Col } from "antd";
import PrimaryButton from "components/Button/PrimaryButton";
import ModalExportacaoContabil from "./ModalExportacaoContabil/index";
import { useState } from "react";
import useFiltroExportacaoContabil from "./../hooks/useFiltroExportacaoContabil";
import { Input } from "@chakra-ui/input";
import { FiltroExportacaoContabil } from "features/exportacao-contabil/typings";
import useDownloadExportacaoContabilExcel from "core/features/exportacao-contabil/hooks/useDownloadExportacaoContabilExcel";
import moment from "moment";
import { downloadLocalExcelFromBlob } from "infra/helpers/download";
import SelectContaBancaria from "components/Input/SelectContaBancaria";

export default function ListarExportacaoContabil() {
  const { filtro, onChangeFiltro } = useFiltroExportacaoContabil();

  const [localFiltro, setLocalFiltro] = useState<
    Partial<FiltroExportacaoContabil>
  >({
    dataInicio: filtro.dataInicio,
    dataFim: filtro.dataFim,
  });

  const [isOpen, setIsOpen] = useState(false);

  const { refetch, isLoading, isFetching } =
    useDownloadExportacaoContabilExcel(filtro);

  const onSubmit = () => {
    const filename = `Exportação Contábil ${moment(
      localFiltro.dataInicio
    ).format("DD_MM_YYYY")} - ${moment(localFiltro.dataFim).format(
      "DD_MM_YYYY"
    )}`;

    refetch().then(async ({ data }) => {
      if (data) {
        downloadLocalExcelFromBlob(data, filename);
      }
    });
  };

  return (
    <Container>
      <PageHeader title={"Exportação Contábil"} />

      <CardDefault>
        <Box>
          <Text fontWeight="medium" fontSize={18} mb={4}>
            Período a ser exportado
          </Text>

          <Box as={Row} gutter={16} mb={10}>
            <Box as={Col} xs={12}>
              <Text mb="2px" fontSize="13px">
                Data inicial
              </Text>
              <Input
                type="date"
                onChange={(ev) => {
                  setLocalFiltro((state) => ({
                    ...state,
                    dataInicio: ev.target.value,
                  }));
                }}
                value={localFiltro.dataInicio}
              />
            </Box>

            <Box as={Col} xs={12}>
              <Text mb="2px" fontSize="13px">
                Data final
              </Text>
              <Input
                type="date"
                onChange={(ev) => {
                  setLocalFiltro((state) => ({
                    ...state,
                    dataFim: ev.target.value,
                  }));
                }}
                onBlur={() => onChangeFiltro(localFiltro)}
                value={localFiltro.dataFim}
              />
            </Box>
          </Box>

          <Box as={Row} gutter={16} mb={10}>
            <Box as={Col} xs={12}>
              <Text mb="2px" fontSize="13px">
                Contas bancárias
              </Text>
              <SelectContaBancaria
                value={filtro.contasBancariasIds}
                onChange={(v: string[]) =>
                  onChangeFiltro({ contasBancariasIds: v })
                }
                mode="multiple"
              />
            </Box>
          </Box>

          <Flex justifyContent="end">
            <PrimaryButton
              isLoading={isLoading || isFetching}
              disabled={!filtro.dataInicio || !filtro.dataFim}
              onClick={onSubmit}
              w="150px"
            >
              Exportar
            </PrimaryButton>
          </Flex>
        </Box>
      </CardDefault>

      {isOpen ? (
        <ModalExportacaoContabil
          onClose={() => setIsOpen(false)}
          filtro={filtro}
          visible={isOpen}
        />
      ) : null}
    </Container>
  );
}
